// ** Logo
import themeConfig from '@configs/themeConfig'
import React from "react"

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner d-flex flex-column justify-content-center align-items-center vh-100'>
      <div className='mt-1 mb-2 w-50 text-center'>
        <img className='img-fluid' src={themeConfig.app.appLogoImage} alt={'logo'}/>
      </div>
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
